import { Handle, HandleProps } from "@xyflow/react";

type Props = HandleProps;

/**
 * A completely invisible connection handle used for receiving connections.
 * The actual draggable connection point is shown via ConnectionHandle component.
 */
export const TransparentHandle = (props: Props) => {
    return (
        <Handle
            {...props}
            style={{
                background: "transparent",
                border: "none",
                width: 1,
                height: 1,
                opacity: 0,
                pointerEvents: "auto",
            }}
        />
    );
};
